export const fillingOptions = [
	{
		value: "LOCAL_PHARMACY",
		label: "Called into local (human) pharmacy"
	},
	{
		value: "RALPHIE_PHARMACY",
		label: "Hello Ralphie pharmacy"
	},
];        